import { render, staticRenderFns } from "./FinanceData.vue?vue&type=template&id=17f83e54&scoped=true&"
import script from "./FinanceData.vue?vue&type=script&lang=js&"
export * from "./FinanceData.vue?vue&type=script&lang=js&"
import style0 from "./FinanceData.vue?vue&type=style&index=0&id=17f83e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../crossBorder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f83e54",
  null
  
)

export default component.exports